/* GA4 dataLayer instrumentation (storefront events only — the Shopify
   Custom Pixel owns checkout events; never fire purchase from here).
   Ecommerce events, cta_click, sign_up/generate_lead, and the PDP
   select_content/view_content engagement events (gallery slides, info chips).
   Reads the JSON blob rendered by snippets/e4e-datalayer.liquid.
   Every handler is wrapped so an analytics failure can never break commerce. */
(function () {
  'use strict';

  var dataEl = document.getElementById('e4e-analytics-data');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  var currency = DATA.currency || 'USD';

  /* Cart line property written by snippets/e4e-buy-box.liquid in preorder
     mode, where no real selling plans exist yet. Keep in sync with the
     buy box and with docs/analytics/shopify-custom-pixel.js. */
  var PLAN_PROPERTY = 'Purchase plan';

  /* cartMap: variant_id -> {qty, item} — the diff baseline for
     add_to_cart / remove_from_cart and the source for begin_checkout. */
  var cartMap = {};
  ((DATA.cart && DATA.cart.items) || []).forEach(function (it) {
    /* Same rule as the `next` map in diffCart: one variant can occupy two lines
       (subscription + one-time), so the BASELINE must accumulate too. Left
       overwriting, it understates the starting quantity and the very first diff
       reports an add or a removal that never happened. */
    if (cartMap[it.variant_id]) {
      cartMap[it.variant_id].qty += it.quantity;
    } else {
      cartMap[it.variant_id] = { qty: it.quantity, item: it };
    }
  });

  function round2(n) {
    return Math.round((Number(n) || 0) * 100) / 100;
  }

  function cleanItem(it, qty) {
    var o = {
      item_id: String(it.item_id || it.variant_id || ''),
      item_name: it.item_name || '',
      price: round2(it.price),
      quantity: qty != null ? qty : it.quantity || 1,
    };
    if (it.item_variant && it.item_variant !== 'Default Title') o.item_variant = it.item_variant;
    if (it.item_brand) o.item_brand = it.item_brand;
    if (it.item_category) o.item_category = it.item_category;
    if (it.selling_plan_name) o.selling_plan_name = it.selling_plan_name;
    return o;
  }

  function itemsValue(items) {
    return items.reduce(function (sum, it) {
      return sum + it.price * it.quantity;
    }, 0);
  }

  /* Event-scoped plan flag, mirroring the checkout pixel's rule exactly so
     the storefront funnel and the purchase event segment the same way.
     Only cart-stage events carry it — view_item has no line to read a plan
     from, and a default of 'one_time' there would be a lie. */
  var PLAN_EVENTS = {
    add_to_cart: 1,
    remove_from_cart: 1,
    view_cart: 1,
    begin_checkout: 1,
  };

  function purchaseType(items) {
    var lines = items || [];
    var withPlan = lines.filter(function (it) {
      return it.selling_plan_name;
    }).length;
    if (withPlan === 0) return 'one_time';
    if (withPlan === lines.length) return 'subscription';
    return 'mixed';
  }

  function pushEcom(eventName, items, extra) {
    try {
      window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce object (GTM idiom)
      var payload = {
        event: eventName,
        page_handle: DATA.pageHandle || null,
        ecommerce: {
          currency: currency,
          value: round2(itemsValue(items)),
          items: items,
        },
      };
      if (PLAN_EVENTS[eventName]) payload.purchase_type = purchaseType(items);
      /* Always set, even to null: GTM's data model keeps the last value pushed,
         so without this a CTA click's placement would ride along on every
         later ecommerce event. Only add_to_cart passes one (see lastCta). */
      payload.placement = null;
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          payload[k] = extra[k];
        });
      }
      window.dataLayer.push(payload);
    } catch (e) {
      /* never break commerce */
    }
  }

  function cartMapItems() {
    return Object.keys(cartMap).map(function (id) {
      return cleanItem(cartMap[id].item, cartMap[id].qty);
    });
  }

  /* One-shot first-party stamp read by the checkout pixel
     (docs/analytics/shopify-custom-pixel.js) on checkout_started: "the theme
     already sent begin_checkout for this checkout". Checkout runs on this
     host, so the cookie is visible there. Express buttons (Shop Pay, Apple
     Pay, PayPal) never pass through the handlers that call this, which is
     exactly how the pixel tells them apart and sends their begin_checkout. */
  function stampThemeCheckout() {
    try {
      document.cookie = '_e4e_bc=' + Date.now() + '; path=/; max-age=900; SameSite=Lax; Secure';
    } catch (e) {
      /* never break commerce */
    }
  }

  /* ---- ad-identity capture (cart attributes) -----------------------
     Subscription renewals bill server-side with no browser, so the only
     moment the buyer's ad-click identity exists is while they still have
     one. Stash it on the cart; Shopify carries cart attributes through to
     order.note_attributes, where the Perzaz senders read them (Meta CAPI
     reads _fbp/_fbc, the GA4 Measurement Protocol reads _ga_client_id).
     Without this, every renewal matches on hashed email alone and GA4
     attaches it to a synthetic derived user. */
  var IDENTITY_ATTRS = ['_fbp', '_fbc', '_ga_client_id'];
  var sentIdentitySig = null; // claimed synchronously; see captureAdIdentity

  function readCookie(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) {
      return '';
    }
  }

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch (e) {
      /* privacy API not loaded yet */
    }
    return true; // matches the theme's consent default (see e4e-datalayer.liquid)
  }

  /* _fbc only exists once the Meta pixel has seen an ad click. On the very
     first pageview the cookie may not be written yet, so rebuild it from
     the fbclid parameter — otherwise click-through attribution is lost. */
  function resolveFbc() {
    var cookie = readCookie('_fbc');
    if (cookie) return cookie;
    try {
      var fbclid = new URLSearchParams(window.location.search).get('fbclid');
      if (fbclid) return 'fb.1.' + Date.now() + '.' + fbclid;
    } catch (e) {
      /* no URLSearchParams / malformed query */
    }
    return '';
  }

  /* "GA1.1.<random>.<ts>" -> "<random>.<ts>" (the client_id GA4 reports). */
  function resolveGaClientId() {
    var ga = readCookie('_ga');
    return ga ? ga.split('.').slice(-2).join('.') : '';
  }

  function captureAdIdentity() {
    try {
      if (!marketingAllowed()) return;

      var attrs = { _fbp: readCookie('_fbp'), _fbc: resolveFbc(), _ga_client_id: resolveGaClientId() };
      var present = IDENTITY_ATTRS.filter(function (k) {
        return attrs[k];
      });
      if (!present.length) return;

      /* Re-send only when a value actually changed, so a browsing session
         costs at most one cart write.

         Two guards, deliberately: sentIdentitySig is claimed synchronously so
         a second call on the same page (add-to-cart landing while the
         page-load backstop is still in flight) cannot slip through before the
         fetch resolves. sessionStorage is written only on success, so a failed
         write is still retried on the next page load. */
      var sig = present
        .map(function (k) {
          return k + '=' + attrs[k];
        })
        .join('|');
      if (sentIdentitySig === sig) return;
      if (sessionStorage.getItem('e4e_ad_identity') === sig) return;
      sentIdentitySig = sig;

      var body = { attributes: {} };
      present.forEach(function (k) {
        body.attributes[k] = attrs[k];
      });

      /* Deferred: Shopify serialises cart writes, and firing this in the
         same tick as Dawn's own add.js can collide. */
      setTimeout(function () {
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          keepalive: true,
        })
          .then(function (r) {
            if (r.ok) sessionStorage.setItem('e4e_ad_identity', sig);
            else sentIdentitySig = null;
          })
          .catch(function () {
            sentIdentitySig = null; // let a later page load try again
          });
      }, 300);
    } catch (e) {
      /* never break commerce */
    }
  }

  /* ---- initial page events ---------------------------------------- */
  try {
    if (DATA.pageType === 'product' && DATA.product) {
      var p = DATA.product;
      var variant =
        (p.variants || []).filter(function (v) {
          return v.id === p.selectedVariantId;
        })[0] ||
        (p.variants || [])[0] ||
        {};
      pushEcom('view_item', [
        cleanItem(
          {
            item_id: variant.sku || variant.id,
            variant_id: variant.id,
            item_name: p.title,
            item_variant: variant.title,
            item_brand: p.vendor,
            item_category: p.type,
            price: variant.price,
          },
          1
        ),
      ]);
    }
    if (DATA.pageType === 'cart') {
      pushEcom('view_cart', cartMapItems());
    }
    /* Backstop: a cart that already had items when this page loaded never
       passes through diffCart, so capture here too. */
    if (Object.keys(cartMap).length) captureAdIdentity();
  } catch (e) {
    /* never break commerce */
  }

  /* ---- add_to_cart / remove_from_cart via cart diff ----------------
     Both Dawn pubsub sources funnel into a diff against cartMap, so we
     never depend on whether an add.js response quantity is cumulative. */
  /* Plan name off a /cart.js line. Two sources, matching the buy box's two
     modes (real selling plans vs the preorder "Purchase plan" line property).
     NB: on cart.js / Liquid, `properties` is a plain OBJECT — the checkout
     pixel sees the same data as a Property[] array and reads it differently. */
  function linePlanName(li) {
    var alloc = li.selling_plan_allocation;
    if (alloc && alloc.selling_plan && alloc.selling_plan.name) return alloc.selling_plan.name;
    if (li.properties && li.properties[PLAN_PROPERTY]) return li.properties[PLAN_PROPERTY];
    return '';
  }

  function lineToItem(li) {
    return {
      variant_id: li.variant_id || li.id,
      item_id: li.sku || li.variant_id || li.id,
      item_name: li.product_title || li.title,
      item_variant: li.variant_title,
      item_brand: li.vendor,
      item_category: li.product_type,
      price: (li.final_price != null ? li.final_price : li.price) / 100,
      quantity: li.quantity,
      selling_plan_name: linePlanName(li),
    };
  }

  function diffCart(lineItems) {
    var next = {};
    lineItems.forEach(function (li) {
      var it = lineToItem(li);
      /* One variant can occupy TWO lines (subscription + one-time), so the map
         must accumulate rather than overwrite — otherwise the second line's
         quantity silently replaces the first and the diff invents a removal. */
      if (next[it.variant_id]) {
        next[it.variant_id].qty += it.quantity;
      } else {
        next[it.variant_id] = { qty: it.quantity, item: it };
      }
    });
    var added = [];
    var removed = [];
    Object.keys(next).forEach(function (id) {
      var delta = next[id].qty - (cartMap[id] ? cartMap[id].qty : 0);
      if (delta > 0) added.push(cleanItem(next[id].item, delta));
      if (delta < 0) removed.push(cleanItem(next[id].item, -delta));
    });
    Object.keys(cartMap).forEach(function (id) {
      if (!next[id]) removed.push(cleanItem(cartMap[id].item, cartMap[id].qty));
    });
    cartMap = next;
    if (added.length) {
      pushEcom('add_to_cart', added, { placement: takeCtaPlacement() });
      captureAdIdentity();
    }
    if (removed.length) pushEcom('remove_from_cart', removed);
  }

  function refreshAndDiff() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.items) diffCart(cart.items);
      })
      .catch(function () {});
  }

  /* Checkout arm of the add-to-cart destination test (assets/product-form.js).
     The shopper goes straight to /checkout, so nobody clicks [name="checkout"]
     and the drawer never opens. Diff the cart now (add_to_cart plus the
     ad-identity cart write), push begin_checkout, then resolve once GTM has
     taken it. The 400ms floor lets the identity write (deferred 300ms,
     keepalive) start before the page unloads. product-form.js caps the wait. */
  window.E4E_beforeCheckout = function () {
    var floor = new Promise(function (resolve) {
      setTimeout(resolve, 400);
    });
    var sent = fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart && cart.items) diffCart(cart.items);
        stampThemeCheckout();
        return new Promise(function (resolve) {
          pushEcom('begin_checkout', cartMapItems(), {
            checkout_flow: 'direct',
            eventCallback: resolve,
            eventTimeout: 1200,
          });
          setTimeout(resolve, 1200);
        });
      })
      .catch(function () {});
    return Promise.all([floor, sent]);
  };

  /* Cart intent events published by assets/cart.js. These are not ecommerce
     payloads: they describe what the shopper was ASKED and what they answered,
     which the ecommerce diff can never see (a cancelled remove changes nothing,
     so diffCart is silent by design). Same flat shape and same placement rule
     as plan_switch above.

     This listener is also the contract any personalization layer consumes --
     it subscribes to the same `e4e:cart:*` events on document. Nothing here
     waits on such a listener; the theme has already acted by the time these
     fire. */
  [
    'remove-intent',
    'remove-confirmed',
    'remove-cancelled',
    'downgrade-intent',
    'downgrade-confirmed',
    'downgrade-cancelled',
  ].forEach(function (name) {
    document.addEventListener('e4e:cart:' + name, function (event) {
      try {
        var detail = (event && event.detail) || {};
        window.dataLayer.push({
          event: 'cart_' + name.replace(/-/g, '_'),
          variant_id: detail.variantId || null,
          item_name: detail.title || null,
          plan_name: detail.to || null,
          placement: document.querySelector('cart-drawer.active') ? 'cart_drawer' : 'cart_page',
          page_handle: DATA.pageHandle || null,
        });
      } catch (e) {
        /* never break a cart mutation for an analytics push */
      }
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      try {
        if (!event) return;
        /* A plan switch keeps the same variant at the same quantity, so diffCart
           sees nothing. Emit it as its own non-ecommerce event first. */
        if (event.source === 'cart-items' && event.planSwitch) {
          var ps = event.planSwitch;
          var lineItems = (event.cartData && event.cartData.items) || [];
          var switched = lineItems[parseInt(ps.line, 10) - 1];
          var linePrice = null;
          if (switched) {
            var raw = switched.final_line_price != null ? switched.final_line_price : switched.line_price;
            if (raw != null) linePrice = round2(raw / 100);
          }
          window.dataLayer.push({
            event: 'plan_switch',
            plan_name: ps.to || null,
            selling_plan_id: ps.sellingPlanId || null,
            variant_id: ps.variantId || null,
            line_price: linePrice,
            placement: document.querySelector('cart-drawer.active') ? 'cart_drawer' : 'cart_page',
            page_handle: DATA.pageHandle || null,
          });
        }
        if (event.source === 'cart-items' && event.cartData && event.cartData.items) {
          diffCart(event.cartData.items);
        } else {
          /* product-form add (or unknown source): /cart.js is authoritative */
          refreshAndDiff();
        }
      } catch (e) {
        /* never break commerce */
      }
    });
  }

  /* ---- which CTA added to cart --------------------------------------
     Every buy button carries data-e4e-placement (pdp_buybox, pdp_sticky,
     pdp_footer, ...). The click is remembered briefly and stamped on the
     add_to_cart it causes, then cleared so a later add from the cart drawer
     is not credited to it. */
  var CTA_WINDOW_MS = 15000;
  var lastCta = null;

  function takeCtaPlacement() {
    var c = lastCta;
    lastCta = null;
    return c && Date.now() - c.at < CTA_WINDOW_MS ? c.placement : null;
  }

  /* ---- begin_checkout (cart page, drawer, notification) ------------
     Accelerated checkout buttons (Shop Pay, Apple Pay, PayPal) bypass this;
     the checkout pixel sends begin_checkout for those from checkout_started,
     and skips it when the stamp below says this handler already did. */
  document.addEventListener('click', function (e) {
    try {
      var target = e.target && e.target.closest && e.target.closest('[name="checkout"]');
      if (target) {
        stampThemeCheckout();
        pushEcom('begin_checkout', cartMapItems());
        return;
      }
      var cta = e.target && e.target.closest && e.target.closest('[data-e4e-event]');
      if (cta) {
        lastCta = { placement: cta.getAttribute('data-e4e-placement') || null, at: Date.now() };
        window.dataLayer.push({
          event: cta.getAttribute('data-e4e-event'),
          cta_text: (cta.textContent || '').trim().slice(0, 100),
          placement: cta.getAttribute('data-e4e-placement') || null,
          page_handle: DATA.pageHandle || null,
        });
      }
    } catch (err) {
      /* never break commerce */
    }
  });

  /* ---- view_cart on drawer open ------------------------------------ */
  try {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var wasActive = drawer.classList.contains('active');
      new MutationObserver(function () {
        var isActive = drawer.classList.contains('active');
        if (isActive && !wasActive) pushEcom('view_cart', cartMapItems());
        wasActive = isActive;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  } catch (e) {
    /* never break commerce */
  }

  /* ---- PDP content engagement: gallery slides + info chips -----------
     select_content = a slide (or chip) the visitor moved to, with `method`
     saying HOW it was reached: thumbnail | dot | arrow | swipe | zoom for
     the Dawn gallery, tab | keyboard | swipe for the e4e-product-info chips.
     view_content = a gallery slide at least half on screen, once per slide
     per page, so views and selects can be ratioed per slide.
     Dawn's slider-component dispatches `slideChanged` (non-bubbling) on the
     viewer for every page change whatever caused it; the clicks that cause
     one are noted first and claimed by the next slideChanged, else the
     change is a swipe. Every key is always pushed (null when n/a) so GTM's
     data model never carries one event's value onto the next. */
  var CONTENT_METHOD_MS = 1500;
  var CONTENT_SETTLE_MS = 400;
  var pendingMethod = null;

  function noteMethod(method) {
    pendingMethod = { method: method, at: Date.now() };
  }

  function noteIsFresh() {
    return !!(pendingMethod && Date.now() - pendingMethod.at < CONTENT_METHOD_MS);
  }

  function takeMethod() {
    var method = noteIsFresh() ? pendingMethod.method : 'swipe';
    pendingMethod = null;
    return method;
  }

  function pushContent(eventName, c) {
    try {
      window.dataLayer.push({
        event: eventName,
        content_type: c.content_type || null,
        content_id: c.content_id != null ? String(c.content_id) : null,
        content_name: c.content_name ? String(c.content_name).trim().slice(0, 100) : null,
        content_position: c.content_position != null ? Number(c.content_position) : null,
        method: c.method || null,
        page_handle: DATA.pageHandle || null,
      });
    } catch (e) {
      /* never break commerce */
    }
  }

  function slideInfo(viewer, li) {
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
    var position = slides.indexOf(li) + 1;
    var img = li.querySelector('img');
    var id = (li.getAttribute('data-media-id') || '').split('-').pop();
    return {
      content_type: 'gallery_slide',
      content_id: id || String(position),
      content_name: (img && img.getAttribute('alt')) || 'Image ' + position,
      content_position: position,
    };
  }

  try {
    var viewers = document.querySelectorAll('slider-component[id^="GalleryViewer-"]');
    if (viewers.length) {
      document.addEventListener(
        'click',
        function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('[id^="GalleryThumbnails-"] [data-target]')) noteMethod('thumbnail');
          else if (t.closest('.e4e-gallery__dot')) noteMethod('dot');
          else if (t.closest('slider-component[id^="GalleryViewer-"] .slider-button')) noteMethod('arrow');
        },
        true
      );
      viewers.forEach(function (viewer) {
        var seen = {};
        var burst = null;
        var timer = null;
        /* Two signals feed one settle window. A smooth scroll (dot,
           multi-slide swipe) fires one slideChanged per slide crossed, and a
           thumbnail click also flips `is-active` (on desktop that flip is the
           ONLY signal: Dawn's thumbnail layout shows one slide and never
           scrolls the list). Report only where the burst settles, with the
           method of the click that started it. The is-active flip counts only
           when a click was noted, so a variant change stays silent. */
        function candidate(li, requireNote) {
          if (!burst) {
            if (requireNote && !noteIsFresh()) return;
            burst = { method: takeMethod() };
          }
          burst.li = li;
          clearTimeout(timer);
          timer = setTimeout(function () {
            var info = slideInfo(viewer, burst.li);
            info.method = burst.method;
            burst = null;
            pushContent('select_content', info);
          }, CONTENT_SETTLE_MS);
        }
        viewer.addEventListener('slideChanged', function (e) {
          var li = e.detail && e.detail.currentElement;
          if (li) candidate(li, false);
        });
        if (window.MutationObserver) {
          var activeWatch = new MutationObserver(function (records) {
            /* Dawn clears is-active on every slide and re-adds it on the
               target in one go; the batch tells old from new. */
            var before = null;
            var after = null;
            records.forEach(function (r) {
              var was = (r.oldValue || '').split(' ').indexOf('is-active') !== -1;
              var is = r.target.classList.contains('is-active');
              if (was && !before) before = r.target;
              if (is && !was) after = r.target;
            });
            /* On a scrolling list is-active lags the slide actually showing
               (swipes never move it), so compare with the visible page too. */
            var items = viewer.sliderItemsToShow || [];
            var scrolls = items.length > 1 && viewer.slider && viewer.slider.scrollWidth > viewer.slider.clientWidth;
            var showing = scrolls ? items[(viewer.currentPage || 1) - 1] : null;
            if (after && after !== before && after !== showing) candidate(after, true);
          });
          viewer.querySelectorAll('.product__media-item').forEach(function (li) {
            activeWatch.observe(li, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
          });
        }
        /* The image itself: opens Dawn's lightbox. */
        viewer.addEventListener('click', function (e) {
          var toggle = e.target && e.target.closest && e.target.closest('.product__media-toggle');
          var li = toggle && toggle.closest('.product__media-item');
          if (!li) return;
          var info = slideInfo(viewer, li);
          info.method = 'zoom';
          pushContent('select_content', info);
        });
        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
              var info = slideInfo(viewer, entry.target);
              if (seen[info.content_id]) return;
              seen[info.content_id] = 1;
              pushContent('view_content', info);
            });
          },
          { threshold: 0.5 }
        );
        viewer.querySelectorAll('.product__media-item').forEach(function (li) {
          io.observe(li);
        });
      });
    }
  } catch (e) {
    /* never break commerce */
  }

  /* assets/e4e-product-info.js dispatches this (bubbling) when a chip is
     selected by the visitor; the theme editor's block-select is not sent. */
  document.addEventListener('e4e:content', function (e) {
    if (e.detail) pushContent('select_content', e.detail);
  });

  /* ---- newsletter signup success (markers rendered on post-back) ---- */
  try {
    document.querySelectorAll('[data-e4e-signup-success]').forEach(function (marker) {
      var placement = marker.getAttribute('data-placement') || 'unknown';
      var key = 'e4e_signup_' + placement;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      window.dataLayer.push({
        event: 'sign_up',
        method: 'newsletter',
        placement: placement,
        page_handle: DATA.pageHandle || null,
      });
      window.dataLayer.push({
        event: 'generate_lead',
        method: 'newsletter',
        placement: placement,
        page_handle: DATA.pageHandle || null,
      });
    });
  } catch (e) {
    /* never break commerce */
  }

  /* ---- Meta advanced matching: newsletter email ---------------------
     Newsletter forms post back to the server, so the email is gone by the
     time the success marker above renders. Hash it on submit and park the
     hash in sessionStorage; snippets/e4e-gtm.liquid hands it to the Meta
     base pixel's fbq('init') as `em` on the next (and every later) page
     this session. Only the SHA-256 hex is stored — never the address.
     Synchronous on purpose: crypto.subtle is async and loses the race with
     the post-back navigation. */
  function sha256Hex(ascii) {
    var K = [
      0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
      0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
      0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
      0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
      0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
      0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
      0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
      0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
    ];
    var H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
    var bytes = unescape(encodeURIComponent(ascii)); // UTF-8
    var len = bytes.length;
    var words = [];
    for (var i = 0; i < len; i++) words[i >> 2] |= bytes.charCodeAt(i) << (24 - (i % 4) * 8);
    words[len >> 2] |= 0x80 << (24 - (len % 4) * 8);
    words[(((len + 8) >> 6) << 4) + 15] = len * 8;
    var w = [];
    for (var j = 0; j < words.length; j += 16) {
      var a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7];
      for (var t = 0; t < 64; t++) {
        if (t < 16) {
          w[t] = words[j + t] | 0;
        } else {
          var x = w[t - 15], y = w[t - 2];
          var s0 = ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
          var s1 = ((y >>> 17) | (y << 15)) ^ ((y >>> 19) | (y << 13)) ^ (y >>> 10);
          w[t] = (w[t - 16] + s0 + w[t - 7] + s1) | 0;
        }
        var S1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        var t1 = (h + S1 + ((e & f) ^ (~e & g)) + K[t] + w[t]) | 0;
        var S0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        var t2 = (S0 + ((a & b) ^ (a & c) ^ (b & c))) | 0;
        h = g; g = f; f = e; e = (d + t1) | 0; d = c; c = b; b = a; a = (t1 + t2) | 0;
      }
      H[0] = (H[0] + a) | 0; H[1] = (H[1] + b) | 0; H[2] = (H[2] + c) | 0; H[3] = (H[3] + d) | 0;
      H[4] = (H[4] + e) | 0; H[5] = (H[5] + f) | 0; H[6] = (H[6] + g) | 0; H[7] = (H[7] + h) | 0;
    }
    var out = '';
    for (var k = 0; k < 8; k++) out += ('00000000' + (H[k] >>> 0).toString(16)).slice(-8);
    return out;
  }

  try {
    document.addEventListener(
      'submit',
      function (ev) {
        try {
          var form = ev.target;
          if (!form || !form.querySelector) return;
          var tags = form.querySelector('input[name="contact[tags]"]');
          if (!tags || String(tags.value).indexOf('newsletter') === -1) return;
          if (!marketingAllowed()) return;
          var input = form.querySelector('input[name="contact[email]"]');
          var email = input ? String(input.value).trim().toLowerCase() : '';
          if (email.indexOf('@') < 1) return;
          sessionStorage.setItem('e4e:am_em', sha256Hex(email));
        } catch (e) {
          /* never block the signup */
        }
      },
      true
    );
  } catch (e) {
    /* never break commerce */
  }
})();
